module.exports = __webpack_public_path__ + "img/emptystate-pending-participants.f2e637d1.svg";